// API Configuration
const API_CONFIG = {
  // localhost: 'http://192.168.1.25:8089',
  localhost: 'http://localhost:8089',  
  server: 'https://pos-api.pro-tech.sg',
  sandbox: 'https://api-sandbox.posjoy.com',
  production: 'https://api.posjoy.com',
};

// Change this manually to switch environments
const CURRENT_ENV = 'server'; // Options: 'localhost', 'sandbox', 'production'

const API_BASE_URL = API_CONFIG[CURRENT_ENV];

// Helper function to build full URLs
export const buildApiUrl = (path) => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${cleanPath}`;
};

// Returns Authorization header object using stored JWT token
export const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};